import { DatePreference } from '@npm-client-frontends/client-frontends-shared-types'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

export const setDateToStartOfDay = (date: Date | undefined | null) => {
  if (!date) return undefined
  date.setHours(0, 0, 0, 0)
  return date
}

export const setDateToEndOfDay = (date: Date | undefined | null) => {
  if (!date) return undefined
  date.setHours(23, 59, 59, 999)
  return date
}

export const formatDateTime = (
  value: string,
  userDateFormat: DatePreference,
) => {
  const inputDate = dayjs(value)
  if (!inputDate.isValid()) {
    return ''
  }

  return inputDate.format(
    userDateFormat === DatePreference.DAY_MONTH ? 'DD/MM/YYYY' : 'MM/DD/YYYY',
  )
}

export const parseDateField = (
  value: string | Date,
  defaultValue: null | undefined = undefined,
) => (isNaN(Date.parse(String(value))) ? defaultValue : new Date(value))

export const formatDateNoTime = (
  value: string,
  userDateFormat: DatePreference,
) => {
  const inputDate = dayjs(value)
  if (!inputDate.isValid()) {
    return ''
  }

  return inputDate.format(
    userDateFormat === DatePreference.DAY_MONTH ? 'DD/MM/YYYY' : 'MM/DD/YYYY',
  )
}

export const formatRelativeDateTime = (
  value: string,
  userDateFormat: DatePreference,
) => {
  const inputDate = dayjs(value)
  if (!inputDate.isValid()) {
    return ''
  }
  const now = dayjs()

  if (inputDate.isSame(now, 'day')) {
    return inputDate.format('h:mm a')
  }

  if (now.diff(inputDate, 'day') < 7) {
    return inputDate.format(
      userDateFormat === DatePreference.DAY_MONTH ? 'ddd DD/MM' : 'ddd MM/DD',
    )
  }

  return inputDate.format(
    userDateFormat === DatePreference.DAY_MONTH ? 'DD/MM/YYYY' : 'MM/DD/YYYY',
  )
}

export function getDateDiff(date1: string, date2: string) {
  return dayjs(date1).diff(dayjs(date2))
}

export function formatDistance(to: string, from: string) {
  return dayjs(to).from(dayjs(from))
}
